// extracted by mini-css-extract-plugin
export default {"activeNav__style":"MobileNav_activeNav__style__aCXy3","normalNav__style":"MobileNav_normalNav__style__DMswN"};